export const periodicalAuthorizeToClosePublication = [
  'RDA',
  'AJU',
  'DNU'
]

export const disabledPeriodical = ['GDA', 'AJU', 'RDA', 'DNU']
